<template>
    <div class="menu-wrapper" v-show="$route.query.expanded!=true && $route.query.expanded != 'true'">
        <div class="greeting">
            <h4>{{greeting}}<img v-if="!roles.includes('LiteStudent')" :src="roles | roleIcon(localStorage.terms)" class="role-icon"></h4>
        </div>
        <clock v-if="!roles.includes('LiteStudent')"></clock>
        <div class="menu" v-show="showMobileMenu">
            <ul class="sidebar" v-if="terms">
                <li v-if="localStorage.roles.indexOf('Student') > -1 && localStorage.terms.toString().split(',').length < 4" @click="showCourseMenu=false">
                    <router-link to="/home" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/dashboard.svg" alt="Dashboard">
                        <span class="menu-label">Dashboard</span>
                    </router-link>
                </li>
                <li v-if="localStorage.roles.includes('Mentor') 
                    || (localStorage.roles.indexOf('Student') > -1 && localStorage.terms.toString().split(',').length === 4)" 
                    @click="showCourseMenu=false">
                    <router-link to="/mentor-dashboard" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/dashboard.svg" alt="Dashboard">
                        <span class="menu-label">Dashboard</span>
                    </router-link>
      
                </li>
                <li v-if="localStorage.roles.indexOf('OnlineDirector') > -1" @click="showCourseMenu=false">
                    <router-link to="/mentor-connection-approval" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/dashboard.svg" alt="Dashboard">
                        <span class="menu-label">Mentor Requests</span>
                    </router-link>
                </li>
                <li v-if="localStorage.roles.includes('GlobalMentor') || localStorage.roles.includes('Recruiter')" @click="showCourseMenu=false">
                    <router-link to="/meetings" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/dashboard.svg" alt="Dashboard">
                        <span v-if="localStorage.roles.includes('GlobalMentor')" class="menu-label">Global Mentor</span>
                        <span v-else class="menu-label">Meetings</span>
                    </router-link>
                </li>
                <li v-if="localStorage.roles.indexOf('CampusStudent') > -1 && localStorage.terms.toString().split(',').length === 4" @click="showCourseMenu=false">
                    <router-link to="/mentor-dashboard" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/dashboard.svg" alt="Dashboard">
                        <span class="menu-label">Mentorship</span>
                    </router-link>
                </li>
                <li v-if="localStorage.roles.includes('OnlineReelReviewer')" @click="showCourseMenu=false">
                    <router-link to="/reel-review" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/dashboard.svg" alt="Dashboard">
                        <span class="menu-label">Reel Review</span>
                    </router-link>
                </li>
                <li v-if="localStorage.roles.includes('CampusStudent')
                          || localStorage.roles.includes('CampusInstructor')
                          || localStorage.hasLibraryAccess == true"
                     @click="showCourseMenu=false">
                    <router-link to="/campus-dashboard" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/dashboard.svg" alt="Dashboard">
                        <span class="menu-label">Video Library</span>
                    </router-link>
                </li>
                <li v-if="(currentTerm && new Date(currentTerm.startDate) <= new Date()) && localStorage.roles.indexOf('Student') > -1" class="course-menu-link">
                    <a @click.prevent="showCourseMenu = !showCourseMenu" href="#" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/courses.svg" alt="Courses">
                        <span class="menu-label">Courses</span>
                    </a>
                    <div class="course-menu" v-if="showCourseMenu" @mouseleave="showCourseMenu=false">
                        <ul>
                            <li v-for="course in courses">
                                <router-link :to="{name: 'course',
                                    params: {
                                        termId: course.term,
                                        courseId: course.associated.courseId,
                                        instanceId: course.id
                                        }
                                    }">
                                    <img :src="course.associated.image">
                                    <h6>{{course.associated.name}}</h6>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li v-if="(currentTerm && new Date(currentTerm.startDate) <= new Date())" @click="showCourseMenu=false">
                    <router-link to="/resources" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/resources.svg" alt="Resources">
                        <span class="menu-label">Course Resources</span>
                    </router-link>
                </li>
                <li v-if="localStorage.roles.indexOf('Student') > -1 && localStorage.terms.toString().split(',').length < 4 && (currentTerm && new Date(currentTerm.startDate) <= new Date())" @click="showCourseMenu=false">
                    <router-link to="/assignments" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/homework.svg" alt="Assignments">
                        <span class="menu-label">Assignments</span>
                    </router-link>
                </li>
                <li v-if="
                        (localStorage.roles.includes('Student')
                          || localStorage.roles.includes('CampusStudent')    
                          || localStorage.roles.includes('Supervisor')                                          
                        ) 
                        && !localStorage.roles.includes('LiteStudent')  
                        " 
                        @click="showCourseMenu=false">
                    <router-link to="/calendar" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/calendar.svg" alt="Calendar">
                        <span class="menu-label">Calendar</span>
                    </router-link>
                </li>
                <li @click="showCourseMenu=false" v-if="!roles.includes('LiteStudent')">
                    <router-link v-if="localStorage.roles.includes('Recruiter')" to="/forum/categories/job-board" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/forum.svg" alt="Forum">
                        <span class="menu-label">Job Board</span>
                    </router-link>
                    <router-link v-else to="/forum" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/forum.svg" alt="Forum">
                        <span class="menu-label">Forum</span>
                    </router-link>
                </li>
                <li @click="showCourseMenu=false" v-if="!roles.includes('LiteStudent')">
                    <router-link to="/galleries" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/galleries.svg" alt="Galleries">
                        <span class="menu-label">Galleries</span>
                    </router-link>
                </li>
                <li @click="showCourseMenu=false" v-if="isNotRecruiter">
                    <router-link to="/kb" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/resources.svg" alt="Resources">
                        <span class="menu-label">Knowledge Base</span>
                    </router-link>
                </li>
                <li @click="showCourseMenu=false" 
                v-if="(localStorage.roles.indexOf('Student') > -1 && localStorage.transitioned != 'true')
                    || localStorage.roles.includes('Supervisor')
                    || localStorage.roles.includes('Mentor')
                    || localStorage.roles.includes('CampusMentor')
                    || localStorage.roles.includes('CampusInstructor')
                    || localStorage.roles.includes('Recruiter')
                    || localStorage.roles.includes('Admin')
                    || localStorage.roles.includes('Faculty')">
                    <router-link to="/help" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/help.svg" alt="Help">
                        <span class="menu-label">Help &#38; Support</span>
                    </router-link>
                </li>
                <li v-if="(localStorage.roles.includes('Student') 
                        || localStorage.roles.includes('CampusStudent')) 
                        && localStorage.terms.toString().split(',').length === 4" 
                    @click="showCourseMenu=false">
                    <router-link to="/final-project" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/final-project.svg" alt="Final Project">
                        <span class="menu-label">Submit Demo Reel</span>
                    </router-link>
                </li>
                <li v-if="(localStorage.roles.includes('CampusStudent') || localStorage.transitioned == 'true') && !roles.includes('LiteStudent')" @click="showCourseMenu=false">
                    <router-link to="/kb-article/29" class="nav-item nav-link">
                        <img class="icon" src="../assets/img/icons/help.svg" alt="Help">
                        <span class="menu-label">Campus Support</span>
                    </router-link>
                </li>
            </ul>
        </div>
        
        <global-checkin @reload="getGlobalCheckins()" v-if="globalCheckins && globalCheckins.length > 0" :alert="globalCheckins[0]"></global-checkin>
    </div>
</template>
<script>
import router from '../router';
import clock from './widgets/Clock.vue';
import GlobalCheckin from './widgets/GlobalCheckin.vue';

import terms from '../services/terms';
import globalMeetings from '../services/global-meetings';


export default {
    data() {
        return {
            authed: false,
            terms: null,
            showMobileMenu: true,
            showCourseMenu: false,
            greetings: ['Hi', 'Hello', 'Bonjour', 'Namaste', 'Salut', 'Hola', 'Ahoy', 'What\'s up', 'Welcome', 'Howdy', 'Greetings', 'Yo', 'Waazzzuup', ],
            globalCheckins: null
        }
    },
    components: {
        clock,
        GlobalCheckin

    },
    mounted() {

        var self = this;
        this.getTerms();

        if (localStorage.roles.includes('GlobalMentor') || localStorage.roles.includes('Recruiter')) {
            self.getGlobalCheckins();
        }

        if (!localStorage.roles.includes('CampusStudent') && localStorage.roles.includes('Student') && localStorage.terms.split(',').length > 3) {
            self.getGlobalCheckins();
        }

        if (window.innerWidth < 1024) this.showMobileMenu = false;
        this.$bus.$on('toggleMobileMenu', function() {
            self.showMobileMenu = !self.showMobileMenu;
        });
    },

    methods: {
        getGlobalCheckins() {
            globalMeetings.getCheckins().then((response) => {
                this.globalCheckins = response.data.globalCheckins;
                this.$forceUpdate();
            });
        },
        getTerms() {
            terms.get(this).then((response) => {
                this.terms = response.data.terms;
            });
        }
    },

    computed: {
        isNotRecruiter() {
            const roles = JSON.parse(localStorage.getItem('roles'));
            return roles.length > 1 || !roles.includes('Recruiter');
        },
        mentorTermHasStarted() {
            if (localStorage.terms.split(',').length > 3) {
                // if the mentor term has not started yet, go to the advanced term dashboard instead
                let mentorTermHasStarted = false;
                let mentorTerm = localStorage.terms.split(',');
                mentorTerm = mentorTerm[mentorTerm.length - 1];
                mentorTerm = this.terms.find((t) => { return t.id == mentorTerm });
                const now = new Date();
                if (now > new Date(mentorTerm.startDate)) mentorTermHasStarted = true;

                return mentorTermHasStarted;
            }

        },
        currentTerm() {
            return this.$store.getters.currentTerm;
        },
        roles() {
            return JSON.parse(localStorage.getItem('roles'));
        },
        courses() {
            var self = this;
            let myCourses = this.$store.getters.courses.filter(function(c) {
                let set = self.currentTerm.selectedCourseSet;
                if (set) {
                    return !c.associated.courseSets || c.associated.courseSets.length === 0 || c.associated.courseSets.includes(set);
                } else {
                    return true;
                }
            });
            if (myCourses.length === 0) {
                return;
            }
            if (myCourses[0].position) {
                myCourses = myCourses.sort((a,b)=>{
                    return a.position - b.position;
                });
            }

            return myCourses;

        },
        greeting() {
            var greeting = this.greetings[Math.floor(Math.random() * this.greetings.length)];
            return greeting + ', ' + localStorage.user_name.split(' ')[0] + '!';
        },
    }


}

</script>
<style lang="scss" scoped>
.menu {
    background: #222;
    margin-bottom: 30px;
    // @media screen and (max-width:1023px) {
    //     width: 200px;
    //     position: absolute;
    //     top: 8rem;
    //     right: 0;
    //     z-index: 9999999;
    // }
}

@media screen and (max-width:1599px) {
    .sidebar {
        padding: 2px 10px;
    }
}

.course-menu-link {
    position: relative;

    .course-menu {
        position: absolute;
        width: 300px;
        right: -300px;
        background: rgba(0, 0, 0, 0.8);
        z-index: 99999999;
        border: 1px solid #1A1A1A;
        text-align: left;

        img {
            max-width: 50px;
            float: left;
            margin: 0 1rem;
        }

        li {
            padding: 1rem;
            border-bottom: solid 1px #666;
            cursor: pointer;
        }
    }
}

.sidebar {
    padding-left: 2rem;
    padding-bottom: 20px;
    text-align: center;
    width: 200px;

    @media screen and (max-width: 1599px) {
        width: auto;
    }

    li {
        padding: 2rem 0;
    }

    i,
    a {
        color: #fff;
    }

    a {
        white-space: nowrap;
        background: red;
    }

    .icon {
        width: 20px;
        height: 20px;
        float: left;
    }

    .menu-label {
        text-transform: uppercase;
        float: left;
        margin-left: 2rem;
        // @media screen and (max-width:1599px) {
        //   display:none;
        // }
    }

    .menu-label:hover {
        color: #33ccff;
    }

    .router-link-active {
        color: #33ccff !important;
    }

    @media screen and (max-width:1599px) {
        .sidebar li:hover .menu-label {
            display: block !important;
        }
    }
}

h4 {
    .role-icon {
        position: relative;
        left: 5px;
        top: -2px;
    }
}

</style>
<style lang="scss">
.main {
    margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// Sidebar.vue?80b6e38e